import type { ConditionBuild, ConditionsState } from "../../../schemas/index.ts";

interface Options {
  conditionsState: ConditionsState;
}

export const getConditionBuildCreate =
  ({ conditionsState: { idByResponseId, byId, slotsByParentId } }: Options) =>
  (responseId: number): ConditionBuild | undefined => {
    const rootConditionId = idByResponseId[responseId];
    if (!rootConditionId) return undefined;

    const getBuilds = (idOrIds: number | number[]): ConditionBuild | ConditionBuild[] | undefined =>
      Array.isArray(idOrIds) ? idOrIds.map(buildWithChildren) : buildWithChildren(idOrIds);

    const buildWithChildren = (id: number): ConditionBuild => ({
      id,
      ...byId[id],
      children: Object.fromEntries(
        Object.entries(slotsByParentId[id] ?? {}).map(([name, slotIdOrIds]) => [
          name,
          slotIdOrIds ? getBuilds(slotIdOrIds) : undefined,
        ]),
      ),
    });

    return buildWithChildren(rootConditionId);
  };

export type GetConditionBuild = ReturnType<typeof getConditionBuildCreate>;
